<template>
    <div id="FAQ">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">FAQ</div>
                    <div class="contentVal">
                        <span>探索和耕耘企业级⼤数据服务领域</span>
                        <span>构建以数据为基础的⽣态，不断为合作伙伴创造价值</span>
                    </div>
                </div>
            </div>
        </div>
        <!--内容区-->
        <div class="contentWrap">
            <div class="contentBox">
                <div class="navList">
                    <div class="firstNav" v-for="(item,index) in navData" :key="index"
                         @click="showSecond(item)">
                        {{item.name}}
                        <div class="secondWrap" v-show="item.flag">
                            <div class="secondNav" v-for="(val,idx) in item.childrenData" :key="idx">
                                {{val.name}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contentVal">
                    <div class="contentValTitle">常见问题</div>
                    <div class="TitleVal">
                        <p>感谢您使用META大数据产品，以下内容主要为常见问题及相应的解答</p>
                        <p>内容较多，可使用ctrl+F进行搜索</p>
                        <p>如果以下内容没有解决您的问题，欢迎您通过电话与我们联系 <span>（9900-009）</span></p>
                    </div>
                    <div class="conBox">
                        <div class="firstT">一级标题</div>
                        <div class="secondT">二级标题</div>
                        <p>
                            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
                        </p>
                        <div class="secondT">二级标题</div>
                        <p>
                            内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FAQ",
        data() {
            return {
                proIndex: 1,
                navData: [
                    {
                        name: "一级标题",
                        flag: false,
                        childrenData: [
                            {name: "二级标题1"}, {name: "二级标题2"}, {name: "二级标题3"}
                        ]
                    },
                    {
                        name: "一级标题",
                        flag: false,
                        childrenData: [
                            {name: "二级标题1"}, {name: "二级标题2"}, {name: "二级标题3"}
                        ]
                    },
                    {
                        name: "一级标题",
                        flag: false,
                    },
                    {
                        name: "一级标题",
                        flag: false,
                    },
                    {
                        name: "一级标题",
                        flag: false,
                    }
                ]
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            showSecond(item) {
                item.flag = !item.flag;
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("contentBox")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #FAQ {
        .bannerWrap {
            height: 298px;
            background: url("../../assets/img/FAQ/bg.png") no-repeat center;
            background-color: #00051D;
        }

        .contentWrap {
            padding-top: 60px;

            .contentBox {
                display: flex;
                justify-content: space-between;
                width: 1200px;
                margin: 0 auto;

                .navList {
                    margin-right: 204px;

                    .firstNav {
                        margin-bottom: 20px;
                        font-size: 24px;
                        cursor: pointer;
                        color: #1E2B4D;

                        .secondWrap {
                            .secondNav {
                                margin-top: 8px;
                                font-size: 16px;
                                color: #1E2B4D;
                            }
                        }
                    }
                }

                .contentVal {
                    flex: 1;

                    .contentValTitle {
                        margin-bottom: 10px;
                        font-size: 40px;
                        color: #152346;
                        text-align: justify;
                    }

                    .TitleVal {
                        margin-bottom: 36px;

                        p {
                            line-height: 34px;
                        }
                    }

                    p {
                        opacity: 0.8;
                        font-size: 16px;
                        color: #152346;
                        line-height: 24px;

                        span {
                            color: #4d65e7;
                        }
                    }

                    .conBox {
                        margin-bottom: 64px;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .firstT {
                            margin-bottom: 12px;
                            font-size: 30px;
                            color: #152346;
                            text-align: justify;
                        }

                        .secondT {
                            margin-bottom: 12px;
                            font-size: 20px;
                            color: #152346;
                            text-align: justify;
                        }

                        p {
                            margin-bottom: 30px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }
        }
    }
</style>